import {Analysis, MoveInfo, RootInfo} from 'ghostban';

//References: github.com/lightvector/KataGo/blob/6a0c33dbdf4d889c96af13e0e763d47f2875b003/cpp/search/searchresults.cpp#L1978
const infoRegex =
    /info\s+(.*?)(?=\n|rootInfo|info|ownership|ownershipStdev|policy|$)/g;
const rootInfoRegex =
    /rootInfo\s+([\s\S]*?)(?=\n|rootInfo|info|ownership|ownershipStdev|policy|$)/;

const moveRegex = /move (\S+)/;
const scoreMeanRegex = /scoreMean (\S+)/;
const priorRegex = /prior (\S+)/;
const utilityLcbRegex = /utilityLcb (\S+)/;
const scoreLeadRegex = /scoreLead (\S+)/;
const scoreSelfPlayRegex = /scoreSelfplay (\S+)/;
const scoreStdevRegex = /scoreStdev (\S+)/;
const utilityRegex = /utility (\S+)/;
const visitsRegex = /visits (\d+)/;
const winrateRegex = /winrate (\S+)/;
const weightRegex = /weight (\S+)/;
const rawStWrErrorRegex = /rawStWrError (\S+)/;
const rawStScoreErrorRegex = /rawStScoreError (\S+)/;
const rawVarTimeLeftRegex = /rawVarTimeLeft (\S+)/;
const lcbRegex = /lcb (\S+)/;
const orderRegex = /order (\d+)/;
const symHashRegex = /symHash (\S+)/;
const thisHashRegex = /thisHash (\S+)/;
const isSymmetryOfRegex = /isSymmetryOf (\S+)/;
const pvRegex = /pv ([A-Z]\d{1,2}(?:\s+[A-Z]\d{1,2})*)/;

const parseInfo = (infoBlock: string): MoveInfo => {
    const move = infoBlock.match(moveRegex)?.[1] || '';
    const pv = infoBlock.match(pvRegex)?.[1]?.split(' ') || [];
    const isSymmetryOf = infoBlock.match(isSymmetryOfRegex)?.[1] || '';
    const visits = parseInt(infoBlock.match(visitsRegex)?.[1] || '0');
    const utility = parseFloat(infoBlock.match(utilityRegex)?.[1] || '0');
    const winrate = parseFloat(infoBlock.match(winrateRegex)?.[1] || '0');
    const scoreMean = parseFloat(infoBlock.match(scoreMeanRegex)?.[1] || '0');
    const scoreStdev = parseFloat(infoBlock.match(scoreStdevRegex)?.[1] || '0');
    const scoreLead = parseFloat(infoBlock.match(scoreLeadRegex)?.[1] || '0');
    const scoreSelfPlay = parseFloat(
        infoBlock.match(scoreSelfPlayRegex)?.[1] || '0'
    );
    const order = parseInt(infoBlock.match(orderRegex)?.[1] || '0');
    const weight = parseFloat(infoBlock.match(weightRegex)?.[1] || '0');
    const prior = parseFloat(infoBlock.match(priorRegex)?.[1] || '0');
    const lcb = parseFloat(infoBlock.match(lcbRegex)?.[1] || '0');
    const utilityLcb = parseFloat(infoBlock.match(utilityLcbRegex)?.[1] || '0');

    return {
        isSymmetryOf,
        lcb,
        move,
        order,
        weight,
        prior,
        pv,
        scoreLead,
        scoreMean,
        scoreSelfPlay,
        scoreStdev,
        utility,
        utilityLcb,
        visits,
        winrate,
    };
};

function parseRootInfo(
    data: string,
    currentPlayer: 'B' | 'W'
): RootInfo | null {
    const rootInfoMatch = data.match(rootInfoRegex);
    if (!rootInfoMatch) return null;

    const rootInfoText = rootInfoMatch[1];

    const scoreLead = parseFloat(
        (rootInfoText.match(scoreLeadRegex) || [])[1] || '0'
    );
    const scoreSelfplay = parseFloat(
        (rootInfoText.match(scoreSelfPlayRegex) || [])[1] || '0'
    );
    const scoreStdev = parseFloat(
        (rootInfoText.match(scoreStdevRegex) || [])[1] || '0'
    );
    const utility = parseFloat(
        (rootInfoText.match(utilityRegex) || [])[1] || '0'
    );
    const visits = parseInt(
        (rootInfoText.match(visitsRegex) || [])[1] || '0',
        10
    );
    const winrate = parseFloat(
        (rootInfoText.match(winrateRegex) || [])[1] || '0'
    );
    const weight = parseFloat(
        (rootInfoText.match(weightRegex) || [])[1] || '0'
    );
    const rawStWrError = parseFloat(
        (rootInfoText.match(rawStWrErrorRegex) || [])[1] || '0'
    );
    const rawStScoreError = parseFloat(
        (rootInfoText.match(rawStScoreErrorRegex) || [])[1] || '0'
    );
    const rawVarTimeLeft = parseFloat(
        (rootInfoText.match(rawVarTimeLeftRegex) || [])[1] || '0'
    );
    const lcb = parseFloat((rootInfoText.match(lcbRegex) || [])[1] || '0');
    const symHash = (rootInfoText.match(symHashRegex) || [])[1] || '';
    const thisHash = (rootInfoText.match(thisHashRegex) || [])[1] || '';

    return {
        currentPlayer,
        scoreLead,
        scoreSelfplay,
        scoreStdev,
        utility,
        visits,
        winrate,
        weight: weight || undefined,
        rawStWrError: rawStWrError || undefined,
        rawStScoreError: rawStScoreError || undefined,
        rawVarTimeLeft: rawVarTimeLeft || undefined,
        lcb: lcb || undefined,
        symHash: symHash || undefined,
        thisHash: thisHash || undefined,
    };
}

export const convertResultToAnalysis = (
    result: string,
    currentPlayer: 'B' | 'W',
    boardSize = 19
) => {
    const infoMatches = result.match(infoRegex) || [];
    const moveInfos = infoMatches.map(parseInfo);
    const rootInfo = parseRootInfo(result, currentPlayer);

    if (!rootInfo) return null;

    const analysis: Analysis = {
        id: JSON.stringify({bx: boardSize, by: boardSize}),
        isDuringSearch: false,
        // isDuringSearch: isDuringSearch,
        moveInfos,
        rootInfo,
        policy: [],
        ownership: [],
        turnNumber: 0,
    };

    return analysis;
};
